"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.teamsAgentsAndAppsTemplates = void 0;
const templateNames_1 = require("../templateNames");
const chatWithYourDataTemplates = [
    {
        id: "custom-copilot-rag-customize-ts",
        name: templateNames_1.TemplateNames.CustomCopilotRagCustomize,
        language: "typescript",
        description: "",
    },
    {
        id: "custom-copilot-rag-customize-js",
        name: templateNames_1.TemplateNames.CustomCopilotRagCustomize,
        language: "javascript",
        description: "",
    },
    {
        id: "custom-copilot-rag-customize-csharp",
        name: templateNames_1.TemplateNames.CustomCopilotRagCustomize,
        language: "csharp",
        description: "",
    },
    {
        id: "custom-copilot-rag-customize-python",
        name: templateNames_1.TemplateNames.CustomCopilotRagCustomize,
        language: "python",
        description: "",
    },
    {
        id: "custom-copilot-rag-azure-ai-search-ts",
        name: templateNames_1.TemplateNames.CustomCopilotRagAzureAISearch,
        language: "typescript",
        description: "",
    },
    {
        id: "custom-copilot-rag-azure-ai-search-js",
        name: templateNames_1.TemplateNames.CustomCopilotRagAzureAISearch,
        language: "javascript",
        description: "",
    },
    {
        id: "custom-copilot-rag-azure-ai-search-csharp",
        name: templateNames_1.TemplateNames.CustomCopilotRagAzureAISearch,
        language: "csharp",
        description: "",
    },
    {
        id: "custom-copilot-rag-azure-ai-search-python",
        name: templateNames_1.TemplateNames.CustomCopilotRagAzureAISearch,
        language: "python",
        description: "",
    },
    {
        id: "custom-copilot-rag-microsoft365-ts",
        name: templateNames_1.TemplateNames.CustomCopilotRagMicrosoft365,
        language: "typescript",
        description: "",
    },
    {
        id: "custom-copilot-rag-microsoft365-js",
        name: templateNames_1.TemplateNames.CustomCopilotRagMicrosoft365,
        language: "javascript",
        description: "",
    },
    {
        id: "custom-copilot-rag-microsoft365-csharp",
        name: templateNames_1.TemplateNames.CustomCopilotRagMicrosoft365,
        language: "csharp",
        description: "",
    },
    {
        id: "custom-copilot-assistant-new-ts",
        name: templateNames_1.TemplateNames.CustomCopilotAssistantNew,
        language: "typescript",
        description: "",
    },
    {
        id: "custom-copilot-assistant-new-js",
        name: templateNames_1.TemplateNames.CustomCopilotAssistantNew,
        language: "javascript",
        description: "",
    },
    {
        id: "custom-copilot-assistant-new-csharp",
        name: templateNames_1.TemplateNames.CustomCopilotAssistantNew,
        language: "csharp",
        description: "",
    },
    {
        id: "custom-copilot-assistant-assistants-api-ts",
        name: templateNames_1.TemplateNames.CustomCopilotAssistantAssistantsApi,
        language: "typescript",
        description: "",
    },
    {
        id: "custom-copilot-assistant-assistants-api-js",
        name: templateNames_1.TemplateNames.CustomCopilotAssistantAssistantsApi,
        language: "javascript",
        description: "",
    },
    {
        id: "custom-copilot-assistant-assistants-api-csharp",
        name: templateNames_1.TemplateNames.CustomCopilotAssistantAssistantsApi,
        language: "csharp",
        description: "",
    },
];
const teamsOtherTemplates = [
    {
        id: "basic-tab-ts",
        name: templateNames_1.TemplateNames.Tab,
        language: "typescript",
        description: "Simple Teams Tab App",
    },
    {
        id: "default-bot-ts",
        name: templateNames_1.TemplateNames.DefaultBot,
        language: "typescript",
        description: "",
    },
    {
        id: "default-bot-js",
        name: templateNames_1.TemplateNames.DefaultBot,
        language: "javascript",
        description: "",
    },
    {
        id: "default-bot-python",
        name: templateNames_1.TemplateNames.DefaultBot,
        language: "python",
        description: "",
    },
    {
        id: "message-extension-v2-ts",
        name: templateNames_1.TemplateNames.DefaultMessageExtension,
        language: "typescript",
        description: "",
    },
    {
        id: "message-extension-v2-python",
        name: templateNames_1.TemplateNames.DefaultMessageExtension,
        language: "python",
        description: "",
    },
    // VS templates below
    {
        id: "basic-tab-csharp",
        name: templateNames_1.TemplateNames.Tab,
        language: "csharp",
        description: "Simple Teams Tab App",
    },
    {
        id: "default-bot-csharp",
        name: templateNames_1.TemplateNames.DefaultBot,
        language: "csharp",
        description: "",
    },
    {
        id: "notification-http-trigger-csharp",
        name: templateNames_1.TemplateNames.NotificationHttpTrigger,
        language: "csharp",
        description: "",
    },
    {
        id: "notification-timer-trigger-csharp",
        name: templateNames_1.TemplateNames.NotificationTimerTrigger,
        language: "csharp",
        description: "",
    },
    {
        id: "notification-http-timer-trigger-csharp",
        name: templateNames_1.TemplateNames.NotificationHttpTimerTrigger,
        language: "csharp",
        description: "",
    },
    {
        id: "notification-webapi-csharp",
        name: templateNames_1.TemplateNames.NotificationWebApi,
        language: "csharp",
        description: "",
    },
    {
        id: "command-and-response-csharp",
        name: templateNames_1.TemplateNames.CommandAndResponse,
        language: "csharp",
        description: "",
    },
    {
        id: "workflow-csharp",
        name: templateNames_1.TemplateNames.Workflow,
        language: "csharp",
        description: "",
    },
    {
        id: "message-extension-v2-csharp",
        name: templateNames_1.TemplateNames.DefaultMessageExtension,
        language: "csharp",
        description: "",
    },
];
exports.teamsAgentsAndAppsTemplates = [
    {
        id: "custom-copilot-basic-ts",
        name: templateNames_1.TemplateNames.CustomCopilotBasic,
        language: "typescript",
        description: "",
    },
    {
        id: "custom-copilot-basic-js",
        name: templateNames_1.TemplateNames.CustomCopilotBasic,
        language: "javascript",
        description: "",
    },
    {
        id: "custom-copilot-basic-csharp",
        name: templateNames_1.TemplateNames.CustomCopilotBasic,
        language: "csharp",
        description: "",
    },
    {
        id: "custom-copilot-basic-python",
        name: templateNames_1.TemplateNames.CustomCopilotBasic,
        language: "python",
        description: "",
    },
    ...chatWithYourDataTemplates,
    {
        id: "teams-collaborator-agent-ts",
        name: templateNames_1.TemplateNames.TeamsCollaboratorAgent,
        language: "typescript",
        description: "",
    },
    ...teamsOtherTemplates,
];
//# sourceMappingURL=teams.js.map